import { buildWhatsAppUrl } from "./whatsapp";

export const LANDING_WHATSAPP_CONTEXT = {
  HERO: "hero",
  PRODUCT: "product",
  QUALITY: "quality",
  CLIENTS: "clients",
  CONTACT: "contact",
  NAV: "nav",
};

export function buildLandingWhatsAppMessage(t, context, params = {}) {
  switch (context) {
    case LANDING_WHATSAPP_CONTEXT.HERO:
      return t("landing.whatsapp.hero", {
        label: params.label || t("landing.whatsapp.defaultAction"),
      });
    case LANDING_WHATSAPP_CONTEXT.PRODUCT:
      return t("landing.whatsapp.product", {
        product: params.product || t("Product"),
      });
    case LANDING_WHATSAPP_CONTEXT.QUALITY:
      return t("landing.whatsapp.quality");
    case LANDING_WHATSAPP_CONTEXT.CLIENTS:
      return t("landing.whatsapp.clients", {
        label: params.label || t("landing.clients.cta"),
      });
    case LANDING_WHATSAPP_CONTEXT.CONTACT:
      return t("landing.whatsapp.contact");
    case LANDING_WHATSAPP_CONTEXT.NAV:
      return t("landing.whatsapp.nav");
    default:
      return t("landing.whatsapp.contact");
  }
}

export function resolveLandingWhatsAppCta(t, context, params = {}) {
  const message = buildLandingWhatsAppMessage(t, context, params);

  return {
    href: buildWhatsAppUrl(message),
    target: "_blank",
    rel: "noopener noreferrer",
  };
}
